import { FC } from "react"
import { useTranslation } from "react-i18next"

import Slider from "./Slider"

interface ISliderConditionProps {
    value: number | null
    defaultValue?: number | null
    disabled?: boolean
    onChange(value: number): void
    validationMessage?: string
}

const SliderCondition: FC<React.PropsWithChildren<ISliderConditionProps>> = ({
    value,
    defaultValue = null,
    disabled,
    onChange,
    validationMessage,
}) => {
    const { t } = useTranslation()
    const valueLabel = value === null ? t('asset.noCondition') : `${value}%`
    const defaultValueLabel = <div className="color-grey-500">{defaultValue === null ? t('asset.noCondition') : `${defaultValue}%`}</div>

    return (
        <Slider
            min={0}
            max={100}
            step={5}
            value={value}
            valueLabel={valueLabel}
            defaultValue={defaultValue}
            defaultValueLabel={defaultValueLabel}
            scaleItems={[
                { label: "0%", left: '0' },
                { label: "25%", left: '25%' },
                { label: "50%", left: '50%' },
                { label: "75%", left: '75%' },
                { label: "100%", right: '0' }
            ]}
            disabled={disabled}
            onChange={onChange}
            validationMessage={validationMessage}
        />
    )
}

export default SliderCondition
